
import React, {
  useEffect, useState,
  // useState,
} from "react";
import { Helmet } from "react-helmet";
// import { useSelector } from "react-redux";
// import { useParams } from "react-router-dom";
import { ScrollToTopOnLoad as LoadFresh } from "../../utils";
// import * as Config from "../../config";
/* - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - */
import {
  Box,
  Typography,
  // useTheme,
  useMediaQuery, useTheme,
} from "@mui/material";
/* - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - */
import NavbarPublic from "../navbarPublic";
import Footer from "../footer";
/* - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - */


const CitadelPage = () => {
  // const [user, setUser] = useState(null);
  // const { userId } = useParams();
  // const token = useSelector((state) => state.token);
  const isNonMobileScreens = useMediaQuery("(min-width:1000px)");
  const [isMobileMenuToggled, setIsMobileMenuToggled] = useState(false);  // TODO: Might not need this. See below.
  const theme = useTheme();
  const pal = theme.palette
  // FOR POPUP - BUT I DON'T SEE WHY I NEED THESE - MAYBE IT's JUST HOW THE POPUP GETS ITS ARGS:
  // const [open, setOpen] = React.useState(false);
  // const [imageUrl, setImageUrl] = React.useState('');

  // const getUser = async () => {
  //   const response = await fetch(`${Config.expressUri}/users/${userId}`, {
  //     method: "GET",
  //     // headers: { Authorization: `Bearer ${token}` },
  //   });
  //   const data = await response.json();
  //   setUser(data);
  // };

  useEffect(() => {
    // getUser();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps


  const handleLinkClickExt = (extUrl) => {
    if (!isNonMobileScreens) {
      setIsMobileMenuToggled(false);  // TODO: Correctness of this for ext link is debatable. Address everywhere.
    }
    window.open(
      extUrl,
      '_blank'
    );
  };


  return (
    <div>
      <Helmet>
        <title>SmartMetal.ai - Citadel</title>
        <meta name="description" content="Citadel" />
      </Helmet>
      <Box>
        <NavbarPublic />
        <Box
          display="block"
          width="100%"
          padding="2rem 4%"
          gap="1.5rem"
          justifyContent="left"
          paddingBottom="0.0rem"
          // sx={{ pb: "0.0rem" }}  // SAME AS ABOVE paddingBottom="0.0rem". BOTH WORK.
        >
          <Typography
            fontWeight="bold"
            fontSize="1.2rem"
            color="red"
            // variant="h5"
            // fontWeight="500"
            // sx={{ mb: "0.7rem" }}
          >
            AUTHORIZED ACCESS ONLY
          </Typography>
        </Box>
        <Box
          width="100%"
          padding="2rem 4%"
          display={isNonMobileScreens ? "flex" : "block"}
          gap="2rem"
          justifyContent="center"
        >
          <Box>

            <span style={{ color: "red", fontWeight: "bold"}}>WARNING!</span>&nbsp;&nbsp;&nbsp;&nbsp; This is a
            &nbsp;&nbsp;&nbsp;<span style={{ color: "red", fontWeight: "bold"}}>RESTRICTED AREA
            &nbsp;&nbsp;&nbsp;&nbsp;[CITADEL]</span>&nbsp;&nbsp;&nbsp;&nbsp; of the SmartMetal.ai site.&nbsp;&nbsp;
            You are now in the restricted area under the URL path of /citadel/.&nbsp;&nbsp; Access to this
            area is granted on an individual basis via explicit authorization from James Mannix
            or a designated agent of SmartMetal.ai.&nbsp;&nbsp; This area is restricted, regardless of password
            protection or any other access control.&nbsp;&nbsp; If you are not authorized to access this
            section /citadel/ and continue unauthorized access,
            you may be held criminally and/or civilly liable.
            <br />
            <strong>[18 U.S. Code § 1030, Cal. Penal Code § 502]</strong>
            <br />
            <br />
            <Typography
              fontWeight="600"
              fontSize="0.9rem"
              color="primary"
              // EXTERNAL LINK because /pgadmin/ is not a path known to this React App's React Router
              // TODO: Via config, we don't necessarily have to hardcode the host:
              onClick={() => handleLinkClickExt("https://smartmetal.ai/ll1l1l1ll/")}
              sx={{
                mt: "0.4rem",
                "&:hover": {
                  cursor: "pointer",
                  color: pal.primary.less_ink,
                },
              }}
            >
              ll1l1l1ll
            </Typography>
            <br />
            <Typography
              fontWeight="600"
              fontSize="0.9rem"
              color="primary"
              // EXTERNAL LINK because /pgadmin/ is not a path known to this React App's React Router
              // TODO: Via config, we don't necessarily have to hardcode the host:
              onClick={() => handleLinkClickExt("https://smartmetal.ai/pgXadmin/")}
              sx={{
                mt: "0.4rem",
                "&:hover": {
                  cursor: "pointer",
                  color: pal.primary.less_ink,
                },
              }}
            >
              Database Administration - PgAdmin 9.2 - PostgreSQL [smpgdb]
            </Typography>
            <br />
            <Typography
              fontWeight="600"
              fontSize="0.9rem"
              color="primary"
              // EXTERNAL LINK because /pgadmin/ is not a path known to this React App's React Router
              // TODO: Via config, we don't necessarily have to hardcode the host:
              onClick={() => handleLinkClickExt("https://smartmetal.ai/aidb/")}
              sx={{
                mt: "0.4rem",
                "&:hover": {
                  cursor: "pointer",
                  color: pal.primary.less_ink,
                },
              }}
            >
              SmartMetal AIDB
            </Typography>
            <br />
            <Typography
              fontWeight="600"
              fontSize="0.9rem"
              color="primary"
              onClick={() => handleLinkClickExt("https://botfolk.ai")}
              sx={{
                mt: "0.4rem",
                "&:hover": {
                  cursor: "pointer",
                  color: pal.primary.less_ink,
                },
              }}
            >
              BotFolk.ai
            </Typography>
            <br />
            <Typography
              fontWeight="600"
              fontSize="0.9rem"
              color="primary"
              onClick={() => handleLinkClickExt("https://autodash.app")}
              sx={{
                mt: "0.4rem",
                "&:hover": {
                  cursor: "pointer",
                  color: pal.primary.less_ink,
                },
              }}
            >
              AutoDash.app
            </Typography>
            <br />
            <Typography
              fontWeight="600"
              fontSize="0.9rem"
              color="primary"
              onClick={() => handleLinkClickExt("https://github.com/jimmygizmo")}
              sx={{
                mt: "0.4rem",
                "&:hover": {
                  cursor: "pointer",
                  color: pal.primary.less_ink,
                },
              }}
            >
              Jimmy Gizmo GitHub
            </Typography>
            <br />
          </Box>
        </Box>
        <Box
          display="block"
          width="100%"
          gap="1.5rem"
          padding="0.0rem"
        >
          <Footer />
        </Box>
      </Box>
    <LoadFresh />
    </div>
  );
};

export default CitadelPage;

